import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import Icon, { ICONS, COLORS } from './icon';

interface TextInputProps {
	placeholder: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
	value: string;
	type?: string;
	required?: boolean;
	inputStyle?: any;
	labelStyle?: any;
	onBlur?: () => void;
	autoFocus?: boolean;
	noAutocomplete?: boolean;
	disabled?: boolean;
	customClassNameProp?: string;
}

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export default function TextInput(props: TextInputProps) {
	const {
		placeholder,
		onChange,
		onKeyUp,
		value,
		type = "text",
		required = false,
		inputStyle,
		labelStyle,
		onBlur,
		autoFocus = false,
		noAutocomplete = false,
		disabled,
		customClassNameProp,
	} = props;
	const [hasValue, setHasValue] = useState(false);
	const [replaceType, setReplaceType] = useState(type);
	const textInput = useRef<HTMLInputElement | null>(null);
	let customClassName;

	function keyUp(event: React.KeyboardEvent<HTMLInputElement>) {
		let targ = event.target as HTMLInputElement;
		setHasValue(!!targ.value);
		onKeyUp?.(event);
	}

	function showPassword() {
		setReplaceType('text');
		setTimeout(() => setReplaceType('password'), 2000);
	}

	function animationStart() {
		setHasValue(true);
	}

	useEffect(() => {
		setTimeout(() => {
			const evt = document.createEvent("HTMLEvents");
			evt.initEvent("change", false, true);
			textInput.current?.dispatchEvent(evt);
		}, 500)

	}, [])

	let style = inputStyle ? inputStyle : {};
	if (type === "password" && replaceType === "password" && isSafari) {
		style.padding = "0px 8px 0px 8px";
	}

	if (disabled) {
		// Thought this opacity looked better and more readable than the default opacity for a disabled text input
		style.opacity = .7;
	}

	customClassName = customClassNameProp === undefined ? "text-input-wrapper" : `text-input-wrapper ${customClassNameProp}`; 

	return (
		<div className={classNames(customClassName, { entered: value !== '' || hasValue })}>
			<input
				name={placeholder}
				autoComplete={noAutocomplete ? 'off' : 'on'}
				onAnimationStart={animationStart}
				autoFocus={autoFocus}
				ref={textInput}
				onBlur={onBlur}
				onKeyUp={keyUp}
				value={value}
				type={replaceType}
				required={required}
				onChange={onChange}
				style={style}
				disabled={disabled}
			/>
			<label style={labelStyle ? labelStyle : {}}>{placeholder}</label>
			{type === 'password' && !!value && (
				<span onClick={showPassword}>
					<Icon name={ICONS.VIEWERS_EYE} size={22} color={COLORS.GRAY} />
				</span>
			)}
		</div>
	)
}